import SettingsContent from '../Wrapper';
import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/wise'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'WISE_SETTINGS.TITLE',
        icon: 'fi fi-sr-square-w',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'wise_settings_index',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};

